import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "state"
    }}>{`State`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Working with the state data and meta data`}</p>
    </blockquote>
    <p>{`A simple Example of how your Form could look like:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Form>
  <Field id="email" type="email" required />
  <Field id="password" type="password" required />
  <Button
    id="button"
    type="submit"
    onClick={(state) => this.handleOnClick(state)}
  >
    Submit
  </Button>
</Form>
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`You can also use `}<inlineCode parentName="p">{`onFocus`}</inlineCode>{`, `}<inlineCode parentName="p">{`onChange`}</inlineCode>{`, and `}<inlineCode parentName="p">{`onBlur`}</inlineCode>{` on every `}<inlineCode parentName="p">{`Field`}</inlineCode>{`, `}<inlineCode parentName="p">{`Select`}</inlineCode>{`, or `}<inlineCode parentName="p">{`RadioGroup`}</inlineCode>{` components to get access to the state of the form (`}<a parentName="p" {...{
          "href": "/react-form-package/react-form-package/on-focus-on-change-on-blur"
        }}>{`more info`}</a>{`)`}</p>
    </blockquote>
    <p>{`As you can see the `}<inlineCode parentName="p">{`<Button />`}</inlineCode>{` component has a `}<inlineCode parentName="p">{`onClick`}</inlineCode>{` property. This property takes a function. The `}<inlineCode parentName="p">{`handleOnClick`}</inlineCode>{` function could look something like:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`async handleOnClick(state) {
  // do something with the state
  // e.g. send data to a server
  try {
    const response = await fetch('https://server.com/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(state.data);
    });
    // do something with the response
  } catch(error) {
    // do something with the error
  }
}
`}</code></pre>
    <p>{`As you can see the `}<inlineCode parentName="p">{`state`}</inlineCode>{` parameter is an object. It has three different properties.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`data`}</strong>{`: `}<inlineCode parentName="li">{`object`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`meta`}</strong>{`: `}<inlineCode parentName="li">{`object`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`formValid`}</strong>{`: `}<inlineCode parentName="li">{`boolean`}</inlineCode></li>
    </ul>
    <p>{`In our case `}<inlineCode parentName="p">{`data`}</inlineCode>{` would hold:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
  "data": {
    "email": "",
    "password": ""
  }
}
`}</code></pre>
    <p><inlineCode parentName="p">{`meta`}</inlineCode>{` would hold:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
  "meta": {
    "email": {
      "initialValue": "",
      "dirty": false,
      "pristine": true,
      "visited": false,
      "touched": false,
      "value": "",
      "valid": false,
      "invalid": true,
      "rules": {
        "type": "email",
        "min": undefined,
        "max": undefined,
        "sameAs": undefined,
        "match": undefined,
        "required": true,
      }
    },
    "password": {
      "initialValue": "",
      "dirty": false,
      "pristine": true,
      "visited": false,
      "touched": false,
      "value": "",
      "valid": false,
      "invalid": true,
      "rules": {
        "type": "password",
        "min": undefined,
        "max": undefined,
        "sameAs": undefined,
        "match": undefined,
        "required": true,
      }
    }
  }
}
`}</code></pre>
    <p><inlineCode parentName="p">{`formValid`}</inlineCode>{` would hold:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
  "formValid": false
}
`}</code></pre>
    <h2 {...{
      "id": "meta-description"
    }}>{`Meta Description`}</h2>
    <p>{`Meta data gives you an overview of what happened on that field. E.g. if a field is `}<inlineCode parentName="p">{`pristine`}</inlineCode>{` you could deside to not send its data to the server since, nothing changed.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property `}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`initialValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode>{` or `}<inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`dirty`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{` if the `}<inlineCode parentName="td">{`value !== initialValue`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`pristine`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{` if the `}<inlineCode parentName="td">{`value === initialValue`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`visited`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{` if this field was focused (`}<inlineCode parentName="td">{`onFocus`}</inlineCode>{`)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`touched`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{` if this field was blurred (`}<inlineCode parentName="td">{`onBlur`}</inlineCode>{`)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode>{` or `}<inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`valid`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{` if this field is valid (passed all rules)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`invalid`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{` if this field is invalid (failed at least one rules)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rules`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the rules for the validation of this field`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rules.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`checkbox`}</inlineCode>{`, `}<inlineCode parentName="td">{`date`}</inlineCode>{`, `}<inlineCode parentName="td">{`textarea`}</inlineCode>{`, `}<inlineCode parentName="td">{`datetime-local`}</inlineCode>{`, `}<inlineCode parentName="td">{`email`}</inlineCode>{`, `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`tel`}</inlineCode>{`, `}<inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`password`}</inlineCode>{`, `}<inlineCode parentName="td">{`time`}</inlineCode>{`, `}<inlineCode parentName="td">{`url`}</inlineCode>{`, `}<inlineCode parentName="td">{`radio`}</inlineCode>{`, `}<inlineCode parentName="td">{`select`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rules.min`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode>{` or `}<inlineCode parentName="td">{`String`}</inlineCode>{` (YYYY-MM-DD)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`textarea`}</inlineCode>{`, `}<inlineCode parentName="td">{`password`}</inlineCode>{`: this field has to have at least `}<inlineCode parentName="td">{`min`}</inlineCode>{` characters; `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`date`}</inlineCode>{`: this field has to be at least `}<inlineCode parentName="td">{`min`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rules.max`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode>{` or `}<inlineCode parentName="td">{`String`}</inlineCode>{` (YYYY-MM-DD)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`textarea`}</inlineCode>{`, `}<inlineCode parentName="td">{`password`}</inlineCode>{`: this field has to have maximum `}<inlineCode parentName="td">{`max`}</inlineCode>{` characters; `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`date`}</inlineCode>{`: this field has to be maximum `}<inlineCode parentName="td">{`max`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rules.match`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`RegEx`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`thie fields has to match the regular expression`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rules.sameAs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`thie fields has to have the same value as the field with id `}<inlineCode parentName="td">{`sameAs`}</inlineCode>{` (e.g. password fields)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rules.required`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`this field is required (has to have a value)`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      